import {
  PURCHASE_URL, TRIAL_URL, ACCOUNT_URL,
} from '../env';

const USER_AGENT = navigator?.userAgent?.toLowerCase() ?? 'NO_USER_AGENT';

const ACCOUNT_PAYLOAD = {
  url: ACCOUNT_URL,
  name: 'UnraidAccount',
  width: 1200,
  height: 850,
};
// eslint-disable-next-line import/prefer-default-export
export const state = {
  // global app
  errorMessage: '',
  errorMessageSubtext: '',
  loading: true,
  submissionFrom: null,
  darkMode: (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches),
  darkTheme: {
    alpha: '#1c1b1b',
    beta: '#f2f2f2',
    gamma: '#999999',
  },
  lightTheme: {
    alpha: '#f2f2f2',
    beta: '#1c1b1b',
    gamma: '#999999',
  },
  csrf: null,
  postMessageError: null,
  // launchpad related
  isLaunchpadOpen: false,
  isPromoOpen: false,
  // upc trigger
  triggerUPC: false,
  /**
   * Server State
   * Set via 3 different actions
   * @LAUNCHPAD - query string params via `initLaunchpad()`
   * @REGWIZ -  DynamoDB.get via `initRegWiz()`
   * @USERPROFILE - via web component props
   */
  ts: null,
  tsHumanReadable: null,
  deviceCount: 0,
  flashproduct: null,
  flashvendor: null,
  guid: '',
  regGuid: '',
  keyfile: null,
  servername: null,
  serverdesc: null,
  wanip: sessionStorage.getItem('upc_wanip') || null,
  site: null,
  wanFQDN: null,
  state: '',
  reggen: 0,
  registered: null,
  internalip: null,
  internalport: null,
  protocol: null,
  license: '',
  expiretime: null,
  regWizTime: null, // if this is set we know the user has registered the server at some point. So we make the UPC show Sign In
  rawServerState: null,
  /**
   * @NOTE: do not set default string value b/c this path needs to be two different default values for older versions.
   * this allows the legacy path to be overwritten. In more recent versions the paths to statephp & myservers.cfg file
   * was moved, hence this being mutated then used in a getter.
   * @see ./getters.js.
   */
  plgPath: null,
  // mutated based on data above
  guidRegistered: false,
  guidValid: null,
  guidValidationRunning: false,
  replaceable: null,
  guidForValidation: null,
  guidBlacklisted: null,
  // DynamoDB
  id: null,
  // Pop-up related
  isPopUpOpen: false,
  regAtOpen: null,
  /**
   * IPS Auth Related
   * @TODO - we can save these and send to Key Server to return user info for auto SignIn/signup
   * then setup RouterGuard for routes that require user auth
   */
  forumaccount: null,
  userEmail: '',
  username: '',
  avatar: '',
  userPassword: '',
  apikey: '',
  ipsValidated: false,
  accountAction: null,
  keyServerAction: '',
  licenseAction: null,
  receivedSuccessNewServerState: null, // feed this Date.now()
  /**
   * payloads
   */
  purchaseWindow: { // and upgrade
    url: new URL(PURCHASE_URL),
    name: 'UnraidPurchaseLicense',
    width: 1198, // if you change these width/height values please update in in Craft's preflight.js
    height: 900,
    sendSessionToPopUp: true,
  },
  redeemWindow: {
    url: new URL(`${PURCHASE_URL}?r=1`),
    name: 'UnraidPurchaseLicense',
    width: 1198, // if you change these width/height values please update in in Craft's preflight.js
    height: 900,
    sendSessionToPopUp: true,
  },
  trialWindow: {
    url: new URL(TRIAL_URL),
    name: 'UnraidStartTrial',
    width: 400,
    height: 400,
    sendSessionToPopUp: true,
  },

  accountPayload: {
    ...ACCOUNT_PAYLOAD,
  },
  accountServerPayload: {
    ...ACCOUNT_PAYLOAD,
    url: `${ACCOUNT_URL}/server`,
  },
  accountRegisterPayload: {
    ...ACCOUNT_PAYLOAD,
    url: `${ACCOUNT_URL}/server/register`,
  },
  accountUnregisterPayload: {
    ...ACCOUNT_PAYLOAD,
    url: `${ACCOUNT_URL}/server/unregister`,
  },
  accountKeyRecoverPayload: {
    ...ACCOUNT_PAYLOAD,
    url: `${ACCOUNT_URL}/server/key-recover`,
  },
  accountKeyReplacePayload: {
    ...ACCOUNT_PAYLOAD,
    url: `${ACCOUNT_URL}/server/key-replace`,
  },
  accountTrialExtendPayload: {
    ...ACCOUNT_PAYLOAD,
    url: `${ACCOUNT_URL}/server/extend-trial`,
  },
  accountTroubleshootPayload: {
    ...ACCOUNT_PAYLOAD,
    url: `${ACCOUNT_URL}/troubleshoot`,
  },

  /** locale */
  locale: 'en_US',
  messages: null,
  /** graphql unraid api */
  graphOnline: false,
  graphReconnected: false,
  myServers: [],
  myServersLoading: false,
  myServersError: null,
  myServersErrorShowSupportBtn: false,
  myServersEnv: null,
  apiVersion: '0.0.0', // absolute fallback
  cloud: null,
  /** for support of 6.10 webgui without plugin included */
  hideMyServers: false,
  osVersion: null,
  plgVersion: null,
  plgInstalled: null,
  hasRemoteApikey: null, // Boolean. set via setStateFromWebComponentProp. used to detect if we need to have the user re-sign in to generate an apikeay for mothership
  config: null, // expect { valid: Boolean, error: String } // enum string expected 'UNKNOWN_ERROR', 'INVALID', 'NO_KEY_SERVER', 'WITHDRAWN', 'UNKNOWN_ERROR'. Only using 'INVALID' right now for errorTooManyDisks
  hasUnraidNetSSL: false, // combined with plgVersion we determine if we present user an error message about sign in required for Unraid Let's Encrypt cert
  flashBackupActivated: false, // if enabled this will be 'true'
  extraOrigins: [],
  myServersOutOfDate: { // use the getter for dynamic configuration not this state value
    enabled: true,
    error: false,
    heading: 'Connect Update Available',
    message: 'Please update to the latest version of the Connect plugin',
    link: '/Plugins',
    linkSameTab: true,
    linkText: 'Learn More',
  },
  devEnv: false,
  signOutTriggered: false,
  apiReport: null,
  /**
   * If true it means the UPC has been loaded in Unraid OS GUI mode Firefox.
   * This will change postMessage targetOrigins to be '*' because of a bug.
   * @see https://app.asana.com/0/inbox/1159909068082281/1201979506171119/1201615796158176
   */
  osGui: USER_AGENT.includes('linux') && USER_AGENT.includes('firefox'),
  pirateKey: sessionStorage.getItem('upc_yargMatey') || false,
  /**
   * Deprecation warning for [hash].unraid.net SSL certs. Deprecation starts 2023-01-01
   */
  deprecatedUnraidSSL: window.location.hostname.includes('.unraid.net'),
  /**
   * Registration via account.unraid.net
   */
  processStarted: false,
  showPostMessageStatus: false,
  keyInstalling: false,
  keyInstallSuccess: false,
  keyInstallFail: false,
  registerSuccess: false,
  registerFail: false,
  unregisterSuccess: false,
  unregisterFail: false,
  accessToken: localStorage.getItem('upc_accessToken') || '', // these values need to be sent by server via state prop
  idToken: localStorage.getItem('upc_idToken') || '', // these values need to be sent by server via state prop
  refreshToken: localStorage.getItem('upc_refreshToken') || '', // these values need to be sent by server via state prop
  iframeUrl: window !== window.parent ? window.location.href : null,
};
